// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"70c28fc8","649":"26603557","784":"d74b03ff","786":"38df7ca2"}[chunkId] + ".chunk.css";
};